import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { FontFace } from '@pcp/core/interfaces';

/**
 * Injection token for the preferred image quality setting.
 * Provides an observable that emits the current image quality preference.
 */
export const PCP_SHARED_PREFERRED_IMAGE_QUALITY = new InjectionToken<Observable<undefined | string>>(
    'PCP_SHARED_PREFERRED_IMAGE_QUALITY'
);

/**
 * Injection token for the service URL.
 * Provides the base URL for API calls.
 */
export const PCP_SHARED_SERVICE_URL = new InjectionToken<string>(
    'PCP_SHARED_SERVICE_URL'
);

/**
 * Injection token for the public blob storage URL.
 * Used to access publicly available blob storage resources.
 */
export const PUBLIC_BLOB_URL = new InjectionToken<string>('PUBLIC_BLOB_URL');

/**
 * Injection token indicating whether the app is running in production mode.
 */
export const IS_PRODUCTION = new InjectionToken<boolean>('IS_PRODUCTION');

/**
 * Injection token for custom fonts configuration.
 * Provides an array of FontFace configurations to be loaded by the app.
 */
export const CUSTOM_FONTS = new InjectionToken<FontFace[]>('CUSTOM_FONTS');

/**
 * Injection token for the client build date.
 * Used for versioning and cache busting.
 */
export const BUILD_DATE = new InjectionToken<string>('BUILD_DATE');
